import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  Pagination,
  Radio,
  Row,
  Select,
  Table,
} from "antd";
import { Option } from "antd/es/mentions";
import moment from "moment";

import productApi from "../../../apis/Product.api";
import { setLoading } from "../../../redux/store/common/commonDuck";
import ContentHeaderComponent from "../../layout/ContentHeaderComponent";

const ProductComponent = () => {
  let history = useHistory();
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));
  const user = useSelector((state) => state.auth.user);

  const [productStatusCount, setProductStatusCount] = useState({
    total: 0,
    selling: 0,
    sold_out: 0,
    unsold: 0,
  });
  const [categoryOption, setCategoryOption] = useState({
    category1: { category_level: 1, category_parent: "0" },
    category2: {},
    category3: {},
  });
  const [searchOptions, setSearchOptions] = useState({
    product_id: 0,
    product_maker_name: "",
    product_name: "",
    product_brand_name: "",
    product_status: "selling",
    category1: "",
    category2: "",
    category3: "",
  });
  const [category1, setCategory1] = useState([
    { category_id: "", category_name: "대분류" },
  ]);
  const [category2, setCategory2] = useState([
    { category_id: "", category_name: "중분류" },
  ]);
  const [category3, setCategory3] = useState([
    { category_id: "", category_name: "소분류" },
  ]);
  const [productItemList, setProductItemList] = useState([]);
  const [selectedRowKey, setSelectedRowKey] = useState([]);
  // const [selectedRow, setSelectedRow] = useState([]);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [offset, setOffset] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalSize, setTotalSize] = useState(0);
  const [orderBy, setOrderBy] = useState("desc");
  const [orderType, setOrderType] = useState("created_at");
  // const [error, setError] = useState("");

  const rowSelection = {
    type: "radio",
    selectedRowKey,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKey(selectedRowKeys);
      // setSelectedRow(selectedRows);
    },
  };

  const columns = [
    {
      title: "상품번호",
      width: 80,
      dataIndex: "product_id",
      key: "product_id",
      ellipsis: true,
      fixed: "left",
      // sorter: (a, b) => {},
      onCell: (record) => {
        return {
          onClick: () => {
            history.push(`/product/register/${record.product_id}`);
          },
        };
      },
    },
    {
      title: "카테고리",
      width: 120,
      dataIndex: "product_category_name",
      key: "product_category_name",
      ellipsis: true,
      render: (value) => {
        if (value === "") {
          return <span>-</span>;
        } else {
          return value;
        }
      },
      onCell: (record) => {
        return {
          onClick: () => {
            history.push(`/product/register/${record.product_id}`);
          },
        };
      },
    },
    {
      title: "브랜드명",
      width: 130,
      dataIndex: "product_brand_name",
      key: "product_brand_name",
      ellipsis: true,
      onCell: (record) => {
        return {
          onClick: () => {
            history.push(`/product/register/${record.product_id}`);
          },
        };
      },
    },
    {
      title: "상품명",
      width: 150,
      dataIndex: "product_name",
      key: "product_name",
      ellipsis: true,
      onCell: (record) => {
        return {
          onClick: () => {
            history.push(`/product/register/${record.product_id}`);
          },
        };
      },
    },
    {
      title: "상품 상태",
      width: 100,
      dataIndex: "is_purchase",
      key: "is_purchase",
      ellipsis: true,
      render: (value, record) => {
        if (record.quantity === 0) {
          return <span>품절</span>;
        } else if (value) {
          return <span>판매중</span>;
        } else {
          return <span>미판매</span>;
        }
      },
      onCell: (record) => {
        return {
          onClick: () => {
            history.push(`/product/register/${record.product_id}`);
          },
        };
      },
    },
    {
      title: "노출여부",
      width: 100,
      dataIndex: "is_admin_product",
      key: "is_admin_product",
      ellipsis: true,
      render: (value, record) => {
        if (value) {
          return "미노출";
        } else {
          return "노출";
        }
      },
      onCell: (record) => {
        return {
          onClick: () => {
            history.push(`/product/register/${record.product_id}`);
          },
        };
      },
    },
    {
      title: "재고수량",
      width: 90,
      dataIndex: "quantity",
      key: "quantity",
      ellipsis: true,
      // sorter: (a, b) => {},
      onCell: (record) => {
        return {
          onClick: () => {
            history.push(`/product/register/${record.product_id}`);
          },
        };
      },
      render: (value) => {
        if (value < 1) {
          return <span>품절</span>;
        } else {
          return <span>{value}</span>;
        }
      },
    },
    {
      title: "판매자",
      width: 120,
      dataIndex: "product_seller_name",
      key: "product_seller_name",
      ellipsis: true,
      onCell: (record) => {
        return {
          onClick: () => {
            history.push(`/product/register/${record.product_id}`);
          },
        };
      },
    },
    {
      title: "판매가",
      width: 90,
      dataIndex: "price_1",
      key: "price_1",
      ellipsis: true,
      // sorter: (a, b) => {},
      onCell: (record) => {
        return {
          onClick: () => {
            history.push(`/product/register/${record.product_id}`);
          },
        };
      },
      render: (value) => <span>{value.toLocaleString()}</span>,
    },
    {
      title: "할인가",
      width: 90,
      dataIndex: "price_2",
      key: "price_2",
      ellipsis: true,
      // sorter: (a, b) => {},
      onCell: (record) => {
        return {
          onClick: () => {
            history.push(`/product/register/${record.product_id}`);
          },
        };
      },
      render: (value) => <span>{value?.toLocaleString()}</span>,
    },
    {
      title: "배송특성",
      width: 90,
      dataIndex: "delivery_type",
      key: "delivery_type",
      ellipsis: true,
      // sorter: (a, b) => {},
      onCell: (record) => {
        return {
          onClick: () => {
            history.push(`/product/register/${record.product_id}`);
          },
        };
      },
    },
    {
      title: "배송비",
      width: 90,
      dataIndex: "delivery_price",
      key: "delivery_price",
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value === null || value === 0) {
          return <span>-</span>;
        } else {
          return value?.toLocaleString();
        }
      },
      onCell: (record) => {
        return {
          onClick: () => {
            history.push(`/product/register/${record.product_id}`);
          },
        };
      },
    },
    {
      title: "등록일",
      width: 160,
      dataIndex: "created_at",
      key: "created_at",
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = moment(value).format("YYYY.MM.DD. HH:mm");
          return date;
        }
      },
      onCell: (record) => {
        return {
          onClick: () => {
            history.push(`/product/register/${record.product_id}`);
          },
        };
      },
    },
    // {
    //     title: '등록자',
    //     width: 90,
    //     dataIndex: 'created_by_name',
    //     key: 'created_by_name',
    //     ellipsis: true,
    //     onCell: (record) => {
    //         return {
    //             onClick: () => {
    //                 history.push(`/product/register/${record.product_id}`)
    //             }
    //         }
    //     }
    // }
  ];

  const productStatusItems = [
    { label: "판매중", value: "selling" },
    { label: "품절", value: "soldOut" },
    { label: "미판매", value: "unsold" },
    { label: "전체", value: "total" },
  ];

  const orderPair = {
    product_id: "상품번호순",
    quantity: "재고수량순",
    price_1: "판매가",
    price_2: "할인가",
    delivery_type: "배송특성순",
    delivery_price: "배송비순",
    created_at: "상품등록일순",
  };

  useEffect(() => {
    getProductStatusInfo();
    getCategoryList(categoryOption.category1);
    readProductList();
  }, []);

  useEffect(() => {
    readProductList();
  }, [offset, pageSize, orderType, orderBy]);

  const getProductStatusInfo = async () => {
    setIsLoading(true);
    try {
      const param = {
        userId: user.id === 724 ? 1 : user.id,
      };
      const res = await productApi.readProductCntByStatus(param);
      if (res.code === 200) {
        setProductStatusCount({
          total: res.result.totalCnt,
          selling: res.result.sellingCnt,
          sold_out: res.result.soldOutCnt,
          unsold: res.result.unsoldCnt,
        });
        setIsLoading(false);
      } else {
        setIsLoading(false);
        alert("정상적인 요청이 아닙니다.");
      }
    } catch (error) {
      setIsLoading(false);
      // setError(error);
      console.log("getProductStatusInfo read error", error);
    }
  };

  const getCategoryList = async (param) => {
    setIsLoading(true);
    try {
      const res = await productApi.readCategoryList(param);
      if (res.code === 200) {
        if (param.category_level === 1) {
          setCategory1([
            { category_id: "", category_name: "대분류" },
            ...res.result,
          ]);
          setCategory2([{ category_id: "", category_name: "중분류" }]);
          setCategory3([{ category_id: "", category_name: "소분류" }]);
        } else if (param.category_level === 2) {
          setCategory2([
            { category_id: "", category_name: "중분류" },
            ...res.result,
          ]);
          setCategory3([{ category_id: "", category_name: "소분류" }]);
        } else if (param.category_level === 3) {
          setCategory3([
            { category_id: "", category_name: "소분류" },
            ...res.result,
          ]);
        }
        setIsLoading(false);
      } else {
        setIsLoading(false);
        alert("정상적인 요청이 아닙니다.");
      }
    } catch (error) {
      setIsLoading(false);
      // setError(error);
      console.log("getCategoryList read error", error);
    }
  };

  const readProductList = async (type = "") => {
    setIsLoading(true);
    try {
      let res;
      if (type === "initial") {
        res = await productApi.readProductList({
          product_id: 0,
          product_maker_name: "",
          product_name: "",
          product_brand_name: "",
          product_status: "selling",
          category1: "",
          category2: "",
          category3: "",
          orderType: "created_at",
          orderBy: "desc",
          offset: 0,
          pageSize: 10,
          userId: user.id === 724 ? 1 : user.id,
        });
      } else if (type === "search") {
        res = await productApi.readProductList({
          ...searchOptions,
          orderType,
          orderBy,
          offset: 0,
          pageSize: 10,
          userId: user.id === 724 ? 1 : user.id,
        });
      } else {
        res = await productApi.readProductList({
          ...searchOptions,
          orderType,
          orderBy,
          offset,
          pageSize,
          userId: user.id === 724 ? 1 : user.id,
        });
      }
      if (res.code === 200) {
        setProductItemList(res.result.productItemMasterList);
        setTotalSize(res.result.totalCnt);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        alert("정상적인 요청이 아닙니다.");
      }
    } catch (error) {
      setIsLoading(false);
      // setError(error);
      console.log("readProductList read error", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "product_id") {
      const reg = /^[0-9]*$/;
      if (value === "") {
        setSearchOptions({ ...searchOptions, [name]: 0 });
      } else if (reg.test(value)) {
        setSearchOptions({ ...searchOptions, [name]: value });
      }
    } else {
      setSearchOptions({ ...searchOptions, [name]: value });
    }
  };

  const handleSelectChange = (value, e) => {
    let searchCategory = {};
    if (e.id === "product_category_1") {
      searchCategory = { category_level: 2, category_parent: value };
      setCategoryOption({
        ...categoryOption,
        category2: searchCategory,
        category3: {},
      });
      setSearchOptions({ ...searchOptions, category1: value });
      getCategoryList(searchCategory);
    } else if (e.id === "product_category_2") {
      searchCategory = { category_level: 3, category_parent: value };
      setCategoryOption({ ...categoryOption, category3: searchCategory });
      setSearchOptions({ ...searchOptions, category2: value });
      getCategoryList(searchCategory);
    } else if (e.id === "product_category_3") {
      setSearchOptions({ ...searchOptions, category3: value });
    }
  };

  const tableOnChange = (pagination, filters, sorter, extra) => {
    if (sorter) {
      //sorting 이벤트가 이루어졌을때
      if (sorter.order) {
        if (sorter.order === "descend") {
          setOrderBy("desc");
        } else if (sorter.order === "ascend") {
          setOrderBy("asc");
        }
        setOrderType(sorter.field);
        //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
      } else {
        setOrderType("created_at");
        setOrderBy("desc");
      }
    }
  };

  /**
   * page 넘김
   */
  const handleChangePagination = (pageNumber) => {
    const offset = (pageNumber - 1) * pageSize;
    setCurrentPageNumber(pageNumber);
    setOffset(offset);
  };

  /**
   * pageSize 변경 handler
   */
  const pageSizeChange = (current, pageSize) => {
    setPageSize(pageSize);
    setOffset(0);
    setCurrentPageNumber(1);
  };

  /**
   * 검색 버튼
   */
  const handleSearchBtnClick = async () => {
    if (searchOptions.category1 !== "" && searchOptions.category2 === "") {
      window.alert(
        "카테고리를 중분류까지 선택하거나 초기화한 뒤에 다시 검색해주시길 바랍니다.",
      );
    } else {
      setOffset(0);
      setCurrentPageNumber(1);
      readProductList("search");
    }
  };

  /**
   * 초기화
   */
  const handleInitialBtnClick = () => {
    setSearchOptions({
      product_id: 0,
      product_maker_name: "",
      product_name: "",
      product_brand_name: "",
      product_status: "selling",
      category1: "",
      category2: "",
      category3: "",
    });
    setCategoryOption({
      category1: { category_level: 1, category_parent: "0" },
      category2: {},
      category3: {},
    });
    setOffset(0);
    setCurrentPageNumber(1);
    setOrderType("created_at");
    setOrderBy("desc");
    readProductList("initial");
  };

  return (
    <>
      <ContentHeaderComponent title="상품 조회/수정" />
      <div className="product-register-wrap">
        {/*상품조회 status*/}
        <Row
          justify="space-around"
          className="product-search-product-status-wrap"
        >
          {/*전체*/}
          <Col className={"product-status-box-col-wrap"} span={6}>
            <Row className="product-status-box-wrap">
              <img
                className="product-status-icon"
                src={`${process.env.REACT_APP_HOST}/assets/images/product/total_product.png`}
              />
              <div className="product-status-text">
                <div>전체</div>
                <div>
                  <span className="product-status-num">
                    {productStatusCount.total}
                  </span>{" "}
                  건
                </div>
              </div>
            </Row>
          </Col>

          {/*판매중*/}
          <Col className={"product-status-box-col-wrap"} span={6}>
            <Row className="product-status-box-wrap">
              <img
                className="product-status-icon"
                src={`${process.env.REACT_APP_HOST}/assets/images/product/total_product.png`}
              />
              <div className="product-status-text">
                <div>판매중</div>
                <div>
                  <span className="product-status-num">
                    {productStatusCount.selling}
                  </span>{" "}
                  건
                </div>
              </div>
            </Row>
          </Col>

          {/*품절*/}
          <Col className={"product-status-box-col-wrap"} span={6}>
            <Row className="product-status-box-wrap">
              <img
                className="product-status-icon"
                src={`${process.env.REACT_APP_HOST}/assets/images/product/total_product.png`}
              />
              <div className="product-status-text">
                <div>품절</div>
                <div>
                  <span className="product-status-num">
                    {productStatusCount.sold_out}
                  </span>{" "}
                  건
                </div>
              </div>
            </Row>
          </Col>

          {/*미판매*/}
          <Col className={"product-status-box-col-wrap"} span={6}>
            <Row className="product-status-box-wrap">
              <img
                className="product-status-icon"
                src={`${process.env.REACT_APP_HOST}/assets/images/product/total_product.png`}
              />
              <div className="product-status-text">
                <div>미판매</div>
                <div>
                  <span className="product-status-num">
                    {productStatusCount.unsold}
                  </span>{" "}
                  건
                </div>
              </div>
            </Row>
          </Col>
        </Row>

        {/*상품검색*/}
        <div className="product-search-box-wrap">
          <Form.Item
            label="검색어"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align="middle" style={{ marginBottom: 15 }}>
              <label className="product-search-box-input-label">상품번호</label>
              <Input
                className="product-search-box-input-wrap"
                name="product_id"
                value={
                  searchOptions.product_id === 0 ? "" : searchOptions.product_id
                }
                onChange={handleChange}
                onPressEnter={handleSearchBtnClick}
              />
              <label className="product-search-box-input-label">제조사명</label>
              <Input
                className="product-search-box-input-wrap"
                name="product_maker_name"
                value={searchOptions.product_maker_name}
                onChange={handleChange}
                onPressEnter={handleSearchBtnClick}
              />
            </Row>
            <Row align="middle">
              <label className="product-search-box-input-label">상품명</label>
              <Input
                className="product-search-box-input-wrap"
                name="product_name"
                value={searchOptions.product_name}
                onChange={handleChange}
                onPressEnter={handleSearchBtnClick}
              />
              <label className="product-search-box-input-label">브랜드명</label>
              <Input
                className="product-search-box-input-wrap"
                name="product_brand_name"
                value={searchOptions.product_brand_name}
                onChange={handleChange}
                onPressEnter={handleSearchBtnClick}
              />
            </Row>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            className="center-label"
            label="상품 상태"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Radio.Group
              name="product_status"
              value={searchOptions.product_status}
              options={productStatusItems}
              onChange={handleChange}
            />
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            className="center-label"
            label="카테고리"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row>
              <Select
                className="product-search-category-select"
                placeholder="대분류"
                value={searchOptions.category1}
                onChange={handleSelectChange}
              >
                {category1?.length !== 0 && (
                  <>
                    {category1.map((category, idx) => (
                      <Option
                        key={`category1_${idx}`}
                        id="product_category_1"
                        value={category.category_id}
                      >
                        {category.category_name}
                      </Option>
                    ))}
                  </>
                )}
              </Select>
              <Select
                className="product-search-category-select"
                placeholder="중분류"
                value={searchOptions.category2}
                onChange={handleSelectChange}
                disabled={Object.keys(categoryOption.category2)?.length === 0}
              >
                {category2?.length !== 0 && (
                  <>
                    {category2.map((category, idx) => (
                      <Option
                        key={`category2_${idx}`}
                        id="product_category_2"
                        value={category.category_id}
                      >
                        {category.category_name}
                      </Option>
                    ))}
                  </>
                )}
              </Select>
              <Select
                className="product-search-category-select"
                placeholder="소분류"
                value={searchOptions.category3}
                onChange={handleSelectChange}
                disabled={Object.keys(categoryOption.category3)?.length === 0}
              >
                {category3?.length !== 0 && (
                  <>
                    {category3.map((category, idx) => (
                      <Option
                        key={`category3_${idx}`}
                        id="product_category_3"
                        value={category.category_id}
                      >
                        {category.category_name}
                      </Option>
                    ))}
                  </>
                )}
              </Select>
            </Row>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          {/*<Form.Item*/}
          {/*    className="center-label"*/}
          {/*    label="기간"*/}
          {/*    labelAlign="left"*/}
          {/*    colon={false}*/}
          {/*    labelCol={{ span: 3 }}*/}
          {/*    wrapperCol={{ span: 21 }}*/}
          {/*>*/}

          {/*</Form.Item>*/}
          {/*<Divider className="product-register-form-input-divider" />*/}
          <Row className="product-search-button-wrap" justify="center">
            <Button
              className="product-search-button search"
              onClick={handleSearchBtnClick}
            >
              검색
            </Button>
            <Button
              className="product-search-button initial"
              onClick={handleInitialBtnClick}
            >
              초기화
            </Button>
          </Row>
        </div>

        {/*상품목록*/}
        <Row
          className="product-register-border-box"
          wrap={false}
          style={{ marginTop: 20, borderBottom: 0 }}
        >
          <span className="product-register-box-title">
            상품목록 (총{" "}
            <span
              className="product-register-box-subtitle"
              style={{ marginLeft: 0 }}
            >
              {totalSize}
            </span>
            개)
          </span>
          <span className="product-list-subtitle">{orderPair[orderType]}</span>
        </Row>
        <div
          className="product-register-border-box"
          wrap={false}
          style={{ padding: "20px 25px 40px", height: "fit-content" }}
        >
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={productItemList}
            loading={isLoading}
            bordered
            size="middle"
            rowKey="product_id"
            rowClassName="coupon-table-row"
            scroll={{ x: "calc(700px + 50%)" }}
            onChange={tableOnChange}
            pagination={false}
          />

          <div style={{ textAlign: "right" }}>
            <Pagination
              showQuickJumper
              showSizeChanger
              onShowSizeChange={pageSizeChange}
              total={totalSize}
              onChange={handleChangePagination}
              style={{ marginTop: 20 }}
              current={currentPageNumber}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductComponent;
